import { LOOKUP_STATUS } from 'flow/types/lookup-status-types';

export const getLookupStatusByContactsSet = (contactsMatchingNumber) => {
    if (contactsMatchingNumber === null) {
        return LOOKUP_STATUS.PENDING;
    } else if (contactsMatchingNumber.isEmpty()) {
        return LOOKUP_STATUS.FAILURE;
    } else {
        return LOOKUP_STATUS.SUCCESS;
    }
};
